import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickLoading = createSelector(
  getOneClickState,
  state => {
    return {
      loading: state.oneClickOrders.loading,
      placing: state.oneClickOrders.placing,
    };
  },
);

export const getOneClickOrders = createSelector(
  getOneClickState,
  state => state.oneClickOrders.ordersAvailable,
);

export const getOneClickSelectedOrder = createSelector(
  getOneClickState,
  state => state.oneClickOrders.selected,
);

export const getOneClickResult = createSelector(
  getOneClickState,
  state => state.oneClickOrders.result,
);

export const getOneClickIsSelectedOrderFromTable = createSelector(
  getOneClickState,
  getOneClickSelectedOrder,
  getOneClickOrders,
  (state, selectedProfile, availableOrders) => ({
    isFromTable: state.oneClickOrders.selectedFromTable,
    canUseBusinessline: state.oneClickOrders.canUseBusinessline,
    selectedProfile,
    availableOrders,
  }),
);

export const ordersAndTable = createSelector(
  getOneClickIsSelectedOrderFromTable,
  ({ isFromTable, canUseBusinessline, selectedProfile, availableOrders: orders }) => ({
    isFromTable,
    canUseBusinessline,
    orders,
    selectedProfile,
  }),
);

export const getOneClickOrderValidity = createSelector(
  getOneClickState,
  state => state.oneClickOrders.valid,
);

export const getOneClickIsValidating = createSelector(
  getOneClickState,
  state => state.oneClickOrders.valid === null,
);
